import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  DESCRIPTION_ALIGN_OPTIONS,
  getDescriptionAlignStyle,
  normalizeDescriptionAlign,
} from '../../shared/activityDescriptionAlign';

export default function ActivityDescription({
  activity,
  dayId,
  isCompleted,
  onUpdateDescriptionAlign,
}) {
  const { t } = useTranslation();
  const align = normalizeDescriptionAlign(activity.descriptionAlign);
  const alignStyle = getDescriptionAlignStyle(align);

  if (!activity.description) {
    return null;
  }

  const handleAlignChange = (nextAlign) => {
    if (!onUpdateDescriptionAlign || nextAlign === align) {
      return;
    }
    onUpdateDescriptionAlign({ ...activity, descriptionAlign: nextAlign }, dayId);
  };

  return (
    <div className="mb-3">
      <div className="d-flex justify-content-end mb-1">
        <ButtonGroup size="sm" className="activity-description-align-controls">
          {DESCRIPTION_ALIGN_OPTIONS.map(({ value, icon, labelKey }) => (
            <Button
              key={value}
              variant={align === value ? 'primary' : 'outline-secondary'}
              onClick={(event) => {
                event.stopPropagation();
                handleAlignChange(value);
              }}
              title={t(labelKey)}
              aria-label={t(labelKey)}
            >
              <i className={`bi ${icon}`}></i>
            </Button>
          ))}
        </ButtonGroup>
      </div>
      <div
        className={`description-text ${isCompleted ? 'text-muted' : ''}`}
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          fontSize: '1rem',
          marginBottom: '0.5rem',
          ...alignStyle,
        }}
        dir={alignStyle.dir}
      >
        {activity.description}
      </div>
    </div>
  );
}
